import React from 'react'
import { Button } from '@demandlocal/components'
import { useNavigate } from 'react-router'
import { ReactComponent as NoAudienceNoInventory } from '../../../../../images/emptyStates/NoAudienceAndInventory.svg'
import { useGetUser } from '../../../../../api/auth/useGetUser'
import { useDealership } from '../../../../../store/zustand/dealershipStore'

export default function UnmappedDealerProfile(): JSX.Element {
  const navigate = useNavigate()
  const user = useGetUser()
  const dealership = useDealership()
  return (
    <div className={'mx-auto my-auto items-center justify-center flex flex-col'}>
      <NoAudienceNoInventory />
      <div className={'pt-4 flex-col flex items-center'}>
        <span className={'font-Spartan font-bold text-base'}>
          This client still needs to be mapped!
        </span>
        <div className={'pt-5'}>
          {user?.data?.role_id === 1 && (
            <Button
              type={'button'}
              onClick={() =>
                navigate(
                  `/dashboard/admin/dealerships/${dealership?._id}/edit/integrations`,
                )
              }>
              Map Client
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}
